import React from "react";
import { Button, Modal } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

interface ConfirmarModalProps {
  isOpen: boolean;
  action: string;
  description: string; 
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmarModal: React.FC<ConfirmarModalProps> = ({
  isOpen,
  action,
  description,
  onConfirm,
  onCancel,
}) => {
  // Determinar el color del botón dependiendo de la acción
  const confirmButtonColor =
    action === "subir"
      ? "success"
      : action === "eliminar"
      ? "failure"
      : "primary";

  // Determinar el color del icono dependiendo de la acción
  const iconColor =
    action === "subir"
      ? "text-green-500"
      : action === "eliminar"
      ? "text-red-500"
      : "text-gray-400";

  return (
    <Modal
      show={isOpen}
      size="lg"
      onClose={onCancel}
      popup
      className="fixed inset-0 z-50 h-screen overflow-y-auto flex items-center justify-center bg-gray-900 bg-opacity-80 dark:bg-opacity-80"
    >
      <Modal.Body className="bg-transparent p-4">
        <div className="text-center">
          <HiOutlineExclamationCircle
            className={`mx-auto mb-4 h-16 w-16 ${iconColor} animate-bounce`}
          />

          <h3 className="mb-3 text-[17px] font-semibold text-gray-600 dark:text-gray-300">
            ¿Estás seguro de que deseas {action} este archivo?
          </h3>

          <p className="text-sm text-gray-500 font-semibold text-gray-500 mt-4 mb-4">
            Archivo: {description}
          </p>

          <div className="flex justify-center gap-3">
            <Button color={confirmButtonColor} onClick={onConfirm}>
              Sí, estoy seguro
            </Button>
            <Button color="gray" onClick={onCancel}>
              No, cancelar
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmarModal;
